import { createContext } from "react";
import type { CopilotPartRole } from "@/features/copilot/lib/copilot-message-plan";

/// The role `planCopilotMessageParts` gave the part being rendered. Parts default to "answer" so
/// anything rendered outside a planned message (tests, other surfaces) keeps its normal look.
export const CopilotPartRoleContext = createContext<CopilotPartRole>("answer");
